import React, { Component, forwardRef } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import Modal from 'react-bootstrap/Modal';
import { connect } from "react-redux";
import { toastError, toastSuccess, DOC_BASE_URL, countryActionId, downloadReport, gstValidationListActionId, businessSectorActionId, primaryServicesActionId, exportMarketsActionId, documentsListActionId, receiptVoucherTypeActionId, memberActionId, bankActionId, paymentModeActionId, receiptAccountTypeActionId, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from '../../../utils/pagination'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Workbook from 'react-excel-workbook'
import Header from '../../../common_components/Header';
import { receipt_entry_save_action, receiptUpdate_action, receiptDetails_action, proformaInvoice_action, deleteReceipt_action, receiptNo_action, generateVoucher_action } from '../../../actions/adminAction/receipt_action'


const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        value={value}
        className="form-control"
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    ></input>
));


class ReceiptAU extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isDelOpen: false,
            isView: false,
            isReadOnly: false,
            isGenVoucherDisabled: false,
            // isRightToDelete: false,
            isAdd: false,
            isDelete: false,
            isUpdate: false,
            isTotalsMatched: false,
            accPaymentId: "",
            voucherTypeId: "",
            memberID: "",
            memberAccountID: "",
            bankAccountId: "",
            currency: "",
            currencyId: "",
            conRate: 1,
            bankAmount: "",
            tdsAmount: "",
            exchdiif: "",
            onAccAmt: "",
            crAmount: 0,
            totalAmount: "",
            receivedAmt: "",
            ledDebAmt: "",
            ledCrAmt: "",
            subLedDebAmt: "",
            subLedCrAmt: "",
            narration: "",
            recptNo: "",
            recptId: "",
            recptDate: new Date(),
            paymentReceivedDate: new Date(),
            pymtModeId: "",
            instrNo: "",
            instruDate: "",
            bankName: "",
            branchName: "",
            voucherTypeList: [],
            memberList: [],
            bankAccountList: [],
            otherChargesList: [{
                account: "",
                amount: ""
            }],
            otherChargesBlankItems: 0,
            paymentModeList: [],
            SelectedInv: [],
            checkedInvList: [],
            checkedAll: false,
            tableRows: [],
            otherCharges: [],
            otherChargesAccountList: [],
            proformaInv: [],
            ledgerList: [],
            subLedgerList: [],
            isOpen: false,
            isContinue: false,
            otherChargesAccountTypeListId: '',
            otherChargesAccountTypeList: [],
            loginAccesslist: [],
            isTotalAmountAvailable: false,

            // Input Errors
            voucherTypeErr: "",
            memberErr: "",
            bankAccountErr: "",
            bankAmountErr: "",
            tdsAmountErr: "",
            pymtModeErr: "",
            otherChargesListErr: "",
            totalsErr: "",
            from: ''
        }
        this.toggleDelModal = this.toggleDelModal.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCheckedInv = this.handleCheckedInv.bind(this)
        this.selectAllInv = this.selectAllInv.bind(this)
        this.calculateTotals = this.calculateTotals.bind(this)
        this.autoFillReceivedAmount = this.autoFillReceivedAmount.bind(this)
        this.handleContinue = this.handleContinue.bind(this)
        this.handleOnAccAmt = this.handleOnAccAmt.bind(this)
        this.createLedgerTable = this.createLedgerTable.bind(this)
        this.proformaInvoice = this.proformaInvoice.bind(this)
        this.createSubLedgerTable = this.createSubLedgerTable.bind(this)
        this.selectMember = this.selectMember.bind(this)
        this.generateReceiptNo = this.generateReceiptNo.bind(this)
        this.preventNegative = this.preventNegative.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.handleBankAmount = this.handleBankAmount.bind(this)
        this.handleTotalAmt = this.handleTotalAmt.bind(this)
        this.handletdsAmount = this.handletdsAmount.bind(this)
        this.getUpdateAccess = this.getUpdateAccess.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
        this.getDeleteAccess = this.getDeleteAccess.bind(this)
        this.otherInputValidate = this.otherInputValidate.bind(this)
        this.saveReceiptEntry = this.saveReceiptEntry.bind(this)
        this.updateReceiptEntry = this.updateReceiptEntry.bind(this)
        this.onPaymentReceivedDate = this.onPaymentReceivedDate.bind(this)
        this.onCancleReceiptEntry = this.onCancleReceiptEntry.bind(this)
        this.getReceiptDetails = this.getReceiptDetails.bind(this)
        this.generateVoucher = this.generateVoucher.bind(this)
        this.handleReceivedAmount = this.handleReceivedAmount.bind(this)
        this.clearVoucher = this.clearVoucher.bind(this)
        this.toggleButtons = this.toggleButtons.bind(this)


    }

    // On Component Load
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            const { memberID } = this.state
            // Fetching DropDown Fill List On Component Load
            if (this.props.location.state != null && (this.props.location.state.is_view || this.props.location.state.is_update)) {
                this.getFillList(memberActionId, '', '', '', '');
            } else {

                this.getFillList(memberActionId, '', '', '', '');
            }

            setTimeout(() => {
                this.getFillList(receiptVoucherTypeActionId, '', '', '', '');
                this.getFillList(bankActionId, '', '', '', '');
                this.getFillList(paymentModeActionId, '', '', '', '');
                this.getFillList(receiptAccountTypeActionId, '', '', '', '', '');
            }, 0);
            console.log("IsView=================", this.props.location.state != null && this.props.location.state.is_view)
            console.log("IsAdd=================", this.props.location.state != null && this.props.location.state.is_add)
            console.log("IsUpdate=================", this.props.location.state != null && this.props.location.state.is_update)
            console.log("ReceiptId====================", this.props.location.state != null && this.props.location.state.receiptId ? this.props.location.state.receiptId : '')

            this.setState({
                isView: this.props.location.state != null && this.props.location.state.is_view ? this.props.location.state.is_view : false,
                isAdd: this.props.location.state != null && this.props.location.state.is_add ? this.props.location.state.is_add : false,
                isUpdate: this.props.location.state != null && this.props.location.state.is_update ? this.props.location.state.is_update : false,
                recptId: this.props.location.state != null && this.props.location.state.receiptId ? this.props.location.state.receiptId : '',
                from: this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : '',
                loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist']
                // isRightToDelete: JSON.parse(sessionStorage.getItem('DummyLoginData')) != null &&
                //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'] != null &&
                //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'].find(obj => obj.ModuleId == 1 && obj.ModuleName == "Receipt").isDelete,
            })
            setTimeout(() => {

                this.props.location.state != null && (this.props.location.state.is_view || this.props.location.state.is_update) && this.getReceiptDetails()
                // this.props.location.state != null && (this.props.location.state.From == "PaymentList" && this.props.location.state.is_add) && this.getPendingReceiptDetails()
            }, 300);
        }
    }

    //toggle generate voucher and clear Voucher buttons
    toggleButtons() {
        const { isGenVoucherDisabled } = this.state
        this.setState({ isGenVoucherDisabled: !isGenVoucherDisabled })
    }

    // handle Received Amount 
    handleReceivedAmount(e, id) {
        const { checkedInvList, totalAmount, receivedAmt, onAccAmt } = this.state
        const value = e.target.value
        // const id = e.target.id
        console.log("recevd checklist 09090--------->", checkedInvList)
        checkedInvList.length > 0 && checkedInvList.map((data, index) => {
            if (value >= 0) {
                if (data.id === id) {
                    data.recvdAmt = value
                    data.recvdAmtErr = ''
                    setTimeout(() => {
                        this.setState({ receivedAmt: value }, () => {
                        })
                    }, 100);
                }
            }
        })
        // On change Of last index in table 

        const lastIndex = checkedInvList.length - 1
        if (checkedInvList[lastIndex].id == id) {
            const { totalReceivedAmt } = this.calculateTotals()
            var OnAccountTotal = parseFloat(totalReceivedAmt) + parseFloat(onAccAmt)
            console.log("AmountOnAcc Total------------->", OnAccountTotal)
            if (totalAmount != OnAccountTotal) {
                // checkedInvList[lastIndex].recvdAmt = ''
                this.setState({ totalsErr: "Total Amounts Are Not matched", isTotalsMatched: false })
                if (checkedInvList[lastIndex].currPend < checkedInvList[lastIndex].recvdAmt) {
                    console.log("===========///------------->",
                        checkedInvList[lastIndex].currPend != checkedInvList[lastIndex].recvdAmt)
                    checkedInvList[lastIndex].recvdAmtErr = 'Received amount must be less than or equal to pending amount'
                    this.setState({ totalsErr: "Pending Amounts Are Not matched" })
                }
            }
            else {
                this.setState({ totalsErr: "", isTotalsMatched: true })
            }
        }
        this.setState({ checkedInvList: checkedInvList }, () => { })
    }

    // get Receipt details
    getReceiptDetails() {
        const { otherChargesList, checkedInvList, proformaInv, memberList } = this.state
        this.setState({ isLoading: true, otherChargesList: [] })
        var receiptId = this.props.location.state.receiptId
        console.log("receiptId=========/////////////////////", receiptId)
        this.props
            .receiptDetails_action(receiptId)
            .then((data) => {
                if (data.error != 1) {
                    console.log("Receipt Details =================", data.data)
                    var otherchargeslist = []
                    if (data.data.otherCharges.length != 0) {
                        otherChargesList.shift();
                    }
                    data.data.otherCharges != null && data.data.otherCharges.map(data => {
                        otherchargeslist = {
                            'account': data.AccountTypeID,
                            'amount': data.Amount
                        }
                        otherChargesList.push(otherchargeslist)
                    })

                    this.selectMember('', data.data.proformaList, data.data.description[0]['MemberID'])

                    this.setState({
                        voucherTypeId: data.data.description[0]['VoucherTypeID'] != null ? data.data.description[0]['VoucherTypeID'] : '',
                        // exhibitorId: data.data.description[0]['ExhRegistrationID'] != null ? data.data.description[0]['ExhRegistrationID'] : '',
                        bankAccountId: data.data.description[0]['BankID'] != null ? data.data.description[0]['BankID'] : '',
                        currencyId: data.data.description[0]['CurrencyID'] != null ? data.data.description[0]['CurrencyID'] : '',
                        currency: data.data.description[0]['Currency'] != null ? data.data.description[0]['Currency'] : '',
                        conRate: data.data.description[0]['ConversionRate'] != null ? data.data.description[0]['ConversionRate'] : '',
                        bankAmount: data.data.description[0]['BankAmount'] != null ? data.data.description[0]['BankAmount'] : '',
                        tdsAmount: data.data.description[0]['TDSAmount'] != null ? data.data.description[0]['TDSAmount'] : '',
                        exchdiif: data.data.description[0]['ExchangeDifference'] != null ? data.data.description[0]['ExchangeDifference'] : '',
                        onAccAmt: data.data.description[0]['OnAccAmount'] != null ? data.data.description[0]['OnAccAmount'] : '',
                        crAmount: data.data.description[0]['CreditAmount'] != null ? data.data.description[0]['CreditAmount'] : '',
                        totalAmount: data.data.description[0]['TotalAmount'] != null ? data.data.description[0]['TotalAmount'] : '',
                        narration: data.data.description[0]['Narration'] != null ? data.data.description[0]['Narration'] : '',
                        recptNo: data.data.description[0]['ReceiptNo'] != null ? data.data.description[0]['ReceiptNo'] : '',
                        recptDate: data.data.description[0]['ReceiptDate'] != null ? new Date(data.data.description[0]['ReceiptDate']) : '',
                        pymtModeId: data.data.description[0]['PaymentModeID'] != null ? data.data.description[0]['PaymentModeID'] : '',
                        paymentReceivedDate: data.data.description[0]['PaymentReceivedDate'] != null ? new Date(data.data.description[0]['PaymentReceivedDate']) : '',
                        instrNo: data.data.description[0]['InstrumentNo'] != null ? data.data.description[0]['InstrumentNo'] : '',
                        instruDate: data.data.description[0]['InstrumentDate'] != null ? new Date(data.data.description[0]['InstrumentDate']) : '',
                        bankName: data.data.description[0]['BankName'] != null ? data.data.description[0]['BankName'] : '',
                        branchName: data.data.description[0]['BranchName'] != null ? data.data.description[0]['BranchName'] : '',
                        // checkedInvList: data.data.proformaList != null ? data.data.proformaList : '',
                        otherChargesList: otherChargesList,
                        isLoading: false
                    })

                    setTimeout(() => {
                        this.calculateTotals()
                        // this.totalAmtsVal()
                    }, 500);
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }


    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        const { bankAccountList, bankAccountId } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === receiptVoucherTypeActionId) {
                        console.log("voucher type data", data.data)
                        this.setState({
                            voucherTypeList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === memberActionId) {
                        console.log("memberList data", data.data)
                        this.setState({
                            memberList: data.data, isLoading: false,
                        })
                    }
                    // exhibitor list for update and view
                    // if (actionID === exhibitorActionId2) {
                    //     console.log("exhibitor data", data.data)
                    //     this.setState({
                    //         exhibitorList: data.data, isLoading: false,
                    //     })
                    // }
                    // bankAccount list
                    if (actionID === bankActionId) {
                        console.log("bankAccount data", data.data)
                        this.setState({
                            bankAccountList: data.data, isLoading: false,
                        }, () => {
                            if (data.data.length == 1) {
                                data.data.map((data) => (
                                    this.setState({
                                        bankAccountId: data.BankID
                                    })
                                ))
                            }

                        })
                    }

                    // OtherCharges list
                    if (actionID === paymentModeActionId) {
                        console.log("Payment Mode data", data.data)
                        this.setState({
                            paymentModeList: data.data, isLoading: false,
                        })
                    }
                    // otherChargesAccountType list
                    if (actionID === receiptAccountTypeActionId) {
                        console.log("receiptAccountTypeActionId data ===========", data.data)
                        this.setState({
                            otherChargesAccountTypeList: data.data, isLoading: false,
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    toggleDelModal() {
        const { isDelOpen } = this.state
        this.setState({ isDelOpen: !isDelOpen })
    }

    handleDelete(e) {
        e.preventDefault()
        const { isDelOpen, recptId } = this.state
        var Id = this.props.location.receiptId
        console.log("idddddddddddd 2222222222", recptId)

        this.setState({ isLoading: true })
        this.props.deleteReceipt_action(recptId)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Receipt Deleted SuccessFully")
                    this.setState({ isLoading: false, isDelOpen: !isDelOpen })
                    setTimeout(() => {
                        this.props.navigate('/receiptlist')
                    }, 2000);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    toggleModal() {
        const { isOpen, memberID } = this.state
        console.log(memberID)
        if (memberID != "" && memberID != "Select") {
            this.setState({ isOpen: !isOpen })
        } else {
            toastError("Please Select member")
        }
    }

    //on Select All Click
    selectAllInv(e) {
        const { checkedAll, proformaInv } = this.state
        console.log(proformaInv, 'ppoppsapo', checkedAll)
        this.setState({ checkedAll: !checkedAll })
        const checked = e.target.checked
        proformaInv.map((data) => {
            console.log(data, checked)
            if (!checkedAll) {
                data.isSelected = 1
            } else {
                data.isSelected = 0
            }
        })
        setTimeout(() => {
            console.log(proformaInv, 'ppoppsapo22')

        }, 500);
        this.setState({ proformaInv: proformaInv })
    }

    handleCheckedInv(e, id) {
        e.preventDefault()
        const { proformaInv, checkedAll, checkedInvList } = this.state

        const checked = e.target.checked
        console.log("0909090 checked////", e.target.type)
        console.log("0909090 proformaInv////", proformaInv)

        proformaInv.map(data => {
            if (data.id === id) {
                console.log('handleCheckedInvc id', id)
                if (!data.isSelected) {
                    data.isSelected = 1
                }
                else {
                    data.isSelected = 0
                    this.setState({ checkedAll: false })
                }
            }
        })
        this.setState({})
        console.log("777777777", checkedInvList)
        // Select All Proforma Invoice
        const AllSelected = proformaInv.every(item => item.isSelected == 1)
        console.log('++++', proformaInv)
        if (AllSelected) {
            this.setState({ checkedAll: true })
        }
        this.calculateTotals()
    }

    calculateTotals() {
        try {
            const { checkedInvList } = this.state
            let totalAmt = 0;
            let totalDueAmt = 0;
            let totalIgst = 0;
            let totalCurrPend = 0;
            let totalReceivedAmt = 0;

            checkedInvList.forEach((data) => {
                if (data.isSelected) {
                    totalAmt += Number(data.totalDue);
                    totalDueAmt += Number(data.Amount);
                    totalIgst += Number(data.igst);
                    totalCurrPend += Number(data.currPend);
                    totalReceivedAmt += Number(data.recvdAmt)
                }
            });
            return {
                totalAmt,
                totalDueAmt,
                totalIgst,
                totalCurrPend,
                totalReceivedAmt
            };

        } catch (e) {
            console.log('exception : ', e);
        }

    }

    handleContinue() {
        const { isOpen, checkedInvList, proformaInv } = this.state
        var list = [...checkedInvList];
        console.log('test....', list);
        for (var i = 0; i < proformaInv.length; i++) {
            if (proformaInv[i].isSelected == 1) {
                console.log("condition1")
                if (list.length == 0) {
                    list.push(proformaInv[i])
                } else {
                    var isAvailable = false;
                    for (var j = 0; j < list.length; j++) {
                        if (list[j].id.toString() == proformaInv[i].id.toString()) {
                            isAvailable = true;
                        }
                    }
                    if (!isAvailable) {
                        list.push(proformaInv[i])
                    }
                }
            } else {
                for (var k = 0; k < list.length; k++) {
                    if (list[k].id == proformaInv[i].id) {
                        list.splice(k, 1)
                    }
                }
            }
        }

        this.setState({ isOpen: !isOpen, checkedInvList: list }, () => {
            // console.log("222=======@@@@@@", checkedInvList)
            this.autoFillReceivedAmount()
        })
        setTimeout(() => {
            this.calculateTotals()
        }, 300);

        setTimeout(() => {
            const { totalCurrPend } = this.calculateTotals()
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            } else {
                this.setState({ onAccAmt: 0.00 })
            }
        }, 500);
    }

    handleOnAccAmt() {
        const { totalAmount, onAccAmt } = this.state
        const { totalCurrPend } = this.calculateTotals()
        const CalOnAccAmt = parseFloat(totalAmount) - parseFloat(totalCurrPend)
        if (CalOnAccAmt >= 0) {
            this.setState({ onAccAmt: CalOnAccAmt.toFixed(2) }, () => {
                console.log("OnAccAmt", onAccAmt)
            })
        } else {
            this.setState({ onAccAmt: 0.00 })
        }
    }

    // auto fill received amount
    autoFillReceivedAmount() {
        const { totalAmount, checkedInvList } = this.state
        console.log(" autoFillReceivedAmount", checkedInvList)
        var balAmount = 0
        for (let i = 0; i < checkedInvList.length; i++) {
            if (checkedInvList.length > 1) {
                if (i == 0) {
                    if (totalAmount >= checkedInvList[i].currPend) {
                        checkedInvList[i].recvdAmt = checkedInvList[i].currPend
                        balAmount = totalAmount - checkedInvList[i].currPend
                    }
                } else {
                    if (balAmount >= checkedInvList[i].currPend) {
                        balAmount = balAmount - checkedInvList[i].currPend
                        checkedInvList[i].recvdAmt = checkedInvList[i].currPend
                    } else {
                        checkedInvList[i].recvdAmt = ""
                    }
                }
            }
            else {
                if (checkedInvList.length == 1) {
                    if (checkedInvList[i].currPend >= totalAmount) {
                        checkedInvList[i].recvdAmt = parseInt(totalAmount)
                    }
                }
            }
        }
    }

    //For Ledger Table Create 
    createLedgerTable() {
        const { ledgerList } = this.state
        var list = [...ledgerList]
        var ledgerColumnArray = []
        var ledgerRowData = []
        // saving all keys of ledger data
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, i) => {
                    ledgerColumnArray.push(key)
                })
            }
        })
        // saving all row data 
        list.map((data) => {
            ledgerRowData.push(data)
        })
        return (
            <div className="col-md-6">
                <p className="mb-0">
                    <strong>Ledger</strong>
                </p>
                <div className="table-responsive mb-1">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead>
                            <tr key={Math.random()} >
                                {
                                    ledgerColumnArray.length > 0 && ledgerColumnArray.map((data, index) => (
                                        <th>{data}</th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {console.log('oooo', ledgerRowData)}
                            {
                                ledgerRowData.length > 0 && ledgerRowData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.Account}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={389.0}
                                                value={data.Debit}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Credit}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    //create sub Ledger Table
    createSubLedgerTable() {
        const { subLedgerList } = this.state
        var list = [...subLedgerList]
        var subLedgerColumnArray = []
        var subLedgerRowData = []
        // saving all keys of ledger data
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, i) => {
                    subLedgerColumnArray.push(key)
                })
            }
        })
        // saving All row data
        list.map((data) => {
            subLedgerRowData.push(data)
        })
        return (
            <div className="col-md-6">
                <p className="mb-0">
                    {" "}
                    <strong>Sub Ledger</strong>
                </p>
                <div className="table-responsive mb-3">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead>
                            <tr key={Math.random()}>
                                {
                                    subLedgerColumnArray.length > 0 && subLedgerColumnArray.map((data) => (
                                        <th>{data}</th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                subLedgerRowData.length > 0 && subLedgerRowData.map((data, index) => (
                                    <tr>
                                        <td>{data.Account}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Debit}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={330.0}
                                                value={data.Credit}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        )

    }

    //handle 
    selectMember(e, proformaListFormDetails, value) {
        console.log('selectMember entry : ', proformaListFormDetails, ' ', value);
        const { isAdd, memberList } = this.state
        var code = ''
        var ID = ''
        if (e) {
            e.preventDefault()
        }
        console.log("selectMember+++++++")
        const { currency } = this.state
        this.setState({ checkedInvList: [], proformaInv: [], checkedAll: false })
        if (isAdd) {
            console.log(e.target.value)
            ID = e.target.value
            this.setState({ memberID: e.target.value, memberErr: "" })
            memberList.length > 0 && memberList.map((data) => {
                if (data.Code == ID) {
                    code = data.Code
                    this.setState({ currency: data.Currency, currencyId: data.CurrencyID })
                }
            })
            this.setState({ memberAccountID: code })
            this.proformaInvoice(code, proformaListFormDetails, ID)
            this.generateReceiptNo(code)
        } else {
            memberList.length > 0 && memberList.map((data) => {
                if (data.Code == value) {
                    // ID = data.ExhRegistrationID
                    code = data.Code
                    this.setState({ currency: data.Currency, currencyId: data.CurrencyID })
                }
            })
            this.setState({
                memberID: value,
                memberErr: "", memberAccountID: code
            })
            console.log('IDIDID', code, value)
            this.proformaInvoice(value, proformaListFormDetails, value)
            // this.generateReceiptNo(value)
        }
    }

    proformaInvoice(code, proformaListFormDetails, ID) {
        const { memberID, isUpdate, isView, checkedInvList } = this.state
        console.log("proInvoices", memberID)
        this.setState({ isLoading: true, proformaInv: [] })
        this.props.proformaInvoice_action(code, ID)
            .then((data) => {
                if (data.error != 1) {
                    var list = []
                    console.log("proInvoices1111111111", data.data)
                    data.data.map(data => {
                        var mapData = {
                            'id': data.ProformaInvoiceID,
                            "service": data.ServiceName,
                            "taxType": data.Tax_Type,
                            "cgst": data.CGST,
                            "sgst": data.SGST,
                            "igst": data.IGST,
                            "totalDue": data.TaxableAmount,
                            "currPend": data.Pending,
                            "no": data.ProformaInvoiceNo,
                            "Date": data.ProformaInvoiceDate,
                            "Amount": data.Total_Payable,
                            "isSelected": 0,
                            "recvdAmt": ""
                        }
                        list.push(mapData)
                    })
                    // this.setState({ proformaInv: proformaInv })
                    // setTimeout(() => {
                    this.setState({ isLoading: false, proformaInv: list }, () => { })
                    // }, 500);

                    var invList = []
                    if (isView || isUpdate) {
                        list.map(item => {
                            proformaListFormDetails.map(data => {
                                console.log(list, data.ProformaInvoiceID, item.id)
                                if (data.ProformaInvoiceID === item.id) {
                                    console.log("###########", item)


                                    item.recvdAmt = data.ReceivedAmount
                                    invList.push(item)
                                }
                            })
                        })
                        var invvlist = [...invList]
                        invvlist.map(data => {
                            data.currPend += data.recvdAmt
                            data.isSelected = 1
                        })
                        console.log("########### checkedInvList", invvlist)
                        this.setState({ checkedInvList: invvlist })
                    }


                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((e) => {
                console.log(e)
            })
    }

    // generate Receipt No 
    generateReceiptNo(id) {
        const { memberID } = this.state
        this.setState({ isLoading: true })
        this.props.receiptNo_action(id)
            .then((data) => {
                console.log("Receipt No--------------> ", data)
                if (data.error != 1) {
                    console.log("Receipt No--------------> ", data.data['receiptNo'])
                    this.setState({ recptNo: data.data['receiptNo'], isLoading: false })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            })
    }

    preventNegative(e) {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            const currentVal = parseFloat(e.target.value);
            const increment = e.key === "ArrowUp" ? 1 : -1;
            const newVal = currentVal + increment;
            if (newVal < 0) {
                e.preventDefault()
            }
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    handleBankAmount(e) {
        this.setState({ bankAmount: parseFloat(e.target.value).toFixed(2) })
        this.handleTotalAmt()
        const { totalCurrPend } = this.calculateTotals()
        setTimeout(() => {
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            }
        }, 500);
    }

    handleTotalAmt() {
        const { bankAmount, tdsAmount } = this.state
        console.log("0202020202", bankAmount, tdsAmt)
        var bankAmt = bankAmount != "" ? bankAmount : "0"
        var tdsAmt = tdsAmount != "" ? tdsAmount : "0"
        console.log("010101010", bankAmt, tdsAmt)
        if (bankAmt != "" && tdsAmt != "") {

            const totalCal = parseFloat(bankAmt) + parseFloat(tdsAmt)
            this.setState({ totalAmount: totalCal.toFixed(2), isTotalAmountAvailable: totalCal > 0 ? true : false }, () => {
                console.log("totalCal ", totalCal.toFixed(2))
            })
        } else {
            this.setState({ totalAmount: "", isTotalAmountAvailable: false })

        }
    }

    // handle tds Amount
    handletdsAmount(e) {
        this.setState({ tdsAmount: parseFloat(e.target.value).toFixed(2), tdsAmountErr: "" })
        this.handleTotalAmt()
        const { totalCurrPend } = this.calculateTotals()
        setTimeout(() => {
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            }
        }, 500);
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    // other Charges Input Validation
    otherInputValidate() {
        const { otherChargesList, otherChargesBlankItems } = this.state
        var isNotAmountContain = false
        var isOtherChargesAccountContain = false
        otherChargesList.map((data) => {
            if (data.account !== "" && data.account !== "Select") {
                isOtherChargesAccountContain = true
                if (isOtherChargesAccountContain) {
                    if (data.amount == "") {
                        isNotAmountContain = true
                    }
                }
            }
        })
        var blankItems = false
        for (let i = 0; i < otherChargesList.length; i++) {
            if (i !== 0) {
                if (otherChargesList[i].account.length === 0 || otherChargesList[i].account == 'Select') {
                    blankItems = true
                    if (otherChargesList[i].amount == '') {
                        blankItems = true
                        console.log("blankkk--->", blankItems)
                    } else {
                        blankItems = false
                    }
                }
                else {
                    blankItems = false
                    if (otherChargesList[i].amount.length === 0) {
                        blankItems = true
                        console.log("blankkk--->", blankItems)
                    } else {
                        blankItems = false
                    }
                }
            }
        }
        console.log("otherInputVAl===================", otherChargesBlankItems)
        setTimeout(() => {
            this.setState({ otherChargesBlankItems: blankItems })
            if (blankItems) {

                this.setState({ otherChargesListErr: "Please Enter Other charges" })
            } else {
                this.setState({ otherChargesListErr: "" })
            }
        }, 400);
    }

    // Input Feilds Validation
    inputValidate() {
        const { voucherTypeId, memberID, bankAccountId, bankAmount, tdsAmount, pymtModeId, isGenVoucherDisabled } = this.state

        if (voucherTypeId == "" || voucherTypeId == "Select") {
            this.setState({ voucherTypeErr: 'Please Select Voucher Type' })
        }
        if (memberID == "" || memberID == "Select") {
            this.setState({ memberErr: 'Please Select Member' })
        }
        if (bankAccountId == "" || bankAccountId == "Select") {
            this.setState({ bankAccountErr: 'Please Select Bank Account' })
        }
        if (bankAmount == "") {
            this.setState({ bankAmountErr: 'Please Enter Bank Amount' })
        }
        if (tdsAmount != null && tdsAmount.toString() == "") {
            this.setState({ tdsAmountErr: 'Please Enter Tds amount' })
        }
        if (isGenVoucherDisabled) {
            if (pymtModeId == "" || pymtModeId == "Select") {
                this.setState({ pymtModeErr: 'Please Select Payment Mode' })
            }
        }
    }

    // Update Receipt Entry
    saveReceiptEntry(e) {
        e.preventDefault()
        const { isLoading, isOpen, isDelOpen, isView, isReadOnly, isGenVoucherDisabled, isAdd, isDelete, isUpdate, isTotalsMatched, accPaymentId, voucherTypeId, memberID, memberAccountID, bankAccountId, currency, currencyId, conRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receivedAmt, ledDebAmt, ledCrAmt, subLedDebAmt, subLedCrAmt, narration, recptNo, recptId, recptDate, paymentReceivedDate, pymtModeId, instrNo, instruDate, bankName, branchName, voucherTypeList, memberList, bankAccountList, otherChargesList, otherChargesBlankItems, paymentModeList, SelectedInv, checkedInvList, checkedAll, tableRows, otherCharges, otherChargesAccountList, proformaInv, ledgerList, subLedgerList, isContinue, otherChargesAccountTypeListId, otherChargesAccountTypeList, loginAccesslist, isTotalAmountAvailable, voucherTypeErr, memberErr, bankAccountErr, bankAmountErr, tdsAmountErr, pymtModeErr, otherChargesListErr, totalsErr, from } = this.state
        //Validate Inpute Feilds on save Receipt
        this.inputValidate()
        this.otherInputValidate()

        if (voucherTypeId !== "" && memberID !== "" && bankAccountId !== "" && bankAmount !== ""
            && tdsAmount.toString() != "") {
            if (voucherTypeErr == "" && memberErr == "" && bankAccountErr == "" &&
                bankAmountErr == "" && tdsAmountErr == "") {
                if (checkedInvList.length > 0) {
                    if (isGenVoucherDisabled) {
                        if (isTotalsMatched) {
                            // console.log("xyxyxyxyxyxyxyyxyxyxyxyxy")
                            if (isGenVoucherDisabled) {
                                if (pymtModeId != "" && pymtModeId != "Select" && pymtModeErr == "") {
                                    // CheckInv List data Preparing to store
                                    var checklnvListData = []
                                    checkedInvList.map(data => {
                                        var mapData = {
                                            'ProformaID': parseInt(data.id),
                                            "ReceivedAmount": !isNaN(data.recvdAmt) && data.recvdAmt != "" &&
                                                data.recvdAmt != null ? parseFloat(data.recvdAmt).toFixed(2) : 0
                                        }
                                        checklnvListData.push(mapData)
                                    });
                                    // otherCharges List data Preparing
                                    var OtherChargesListData = []
                                    otherChargesList.map((data) => {
                                        var mapdata = {
                                            'Account_type_ID': parseInt(data.account),
                                            'Amount': !isNaN(data.amount) && data.amount != "" &&
                                                data.amount != null ? parseFloat(data.amount).toFixed(2) : 0
                                        }
                                        OtherChargesListData.push(mapdata)
                                    })
                                    console.log("Othercharges LIst ---------> ", otherChargesList)
                                    this.setState({ isLoading: true })
                                    this.props.receipt_entry_save_action(voucherTypeId, memberID, bankAccountId, currencyId, conRate, bankAmount, tdsAmount, exchdiif,
                                        onAccAmt, crAmount, totalAmount, recptNo, recptDate, pymtModeId, paymentReceivedDate, instrNo, instruDate, bankName,
                                        branchName, narration, checklnvListData, OtherChargesListData, accPaymentId)
                                        .then((data) => {
                                            if (data.error != 1) {
                                                this.setState({ isLoading: false })
                                                toastSuccess("Receipt Save Succesfully")
                                                setTimeout(() => {
                                                    this.props.navigate('/receiptlist')
                                                }, 2000);

                                            } else {
                                                if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                                    //after session expire.....................
                                                    sessionStorage.clear();
                                                    this.props.navigate("/");
                                                    setTimeout(() => {
                                                        toastError(data.msg);
                                                    }, 2000);
                                                } else {
                                                    toastError(data.data);
                                                }
                                                this.setState({ isLoading: false })
                                                toastError(data.msg)
                                            }
                                        }).catch((e) => {
                                            console.log(e)
                                        })
                                }
                            } else {
                                toastError("Please Generate Voucher")
                            }
                        } else {
                            toastError("Total Amounts Not Matched")
                        }
                    }
                    else {
                        toastError("Please Generate Voucher")
                    }
                } else {
                    toastError("Please Select Invoices")
                }
            } else {
                toastError("Please Fill Mandatory Fields")
            }
        }
    }

    // Update Receipt Entry
    updateReceiptEntry() {
        const { isLoading, isOpen, isDelOpen, isView, isReadOnly, isGenVoucherDisabled, isAdd, isDelete, isUpdate, isTotalsMatched, accPaymentId, voucherTypeId, memberID, memberAccountID, bankAccountId, currency, currencyId, conRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receivedAmt, ledDebAmt, ledCrAmt, subLedDebAmt, subLedCrAmt, narration, recptNo, recptId, recptDate, paymentReceivedDate, pymtModeId, instrNo, instruDate, bankName, branchName, voucherTypeList, memberList, bankAccountList, otherChargesList, otherChargesBlankItems, paymentModeList, SelectedInv, checkedInvList, checkedAll, tableRows, otherCharges, otherChargesAccountList, proformaInv, ledgerList, subLedgerList, isContinue, otherChargesAccountTypeListId, otherChargesAccountTypeList, loginAccesslist, isTotalAmountAvailable, voucherTypeErr, memberErr, bankAccountErr, bankAmountErr, tdsAmountErr, pymtModeErr, otherChargesListErr, totalsErr, from } = this.state
        const { totalReceivedAmt } = this.calculateTotals()
        //Validate Inpute Feilds on Update Receipt Receipt
        this.inputValidate()
        this.otherInputValidate()

        if (voucherTypeId !== "" && memberID !== "" && bankAccountId !== "" && bankAmount !== ""
            && tdsAmount.toString() != "") {
            if (voucherTypeErr == "" && memberErr == "" && bankAccountErr == "" && bankAmountErr == ""
                && tdsAmountErr == "") {
                if (checkedInvList.length > 0) {
                    console.log("02020202020202020", isTotalsMatched)
                    if (isGenVoucherDisabled) {
                        if (isTotalsMatched) {
                            if (isGenVoucherDisabled) {
                                if (pymtModeId != "" && pymtModeId != "Select" && pymtModeErr == "") {
                                    // preparing checked Invoice list data to store
                                    var checklnvListData = [];
                                    checkedInvList.map((data) => {
                                        var mapData = {
                                            "ProformaID": parseInt(data.id),
                                            "ReceivedAmount": parseFloat(data.recvdAmt).toFixed(2),
                                        }
                                        checklnvListData.push(mapData)
                                    });
                                    // other charges list data preparing to store
                                    var OtherChargesListData = [];
                                    otherChargesList.map((data) => {
                                        var mapdata = {
                                            "Account_type_ID": parseInt(data.account),
                                            "Amount": parseFloat(data.amount).toFixed(2)
                                        }
                                        OtherChargesListData.push(mapdata)
                                    })
                                    this.setState({ isLoading: true })
                                    this.props.receiptUpdate_action(recptId, voucherTypeId, memberID, bankAccountId, currencyId, conRate, bankAmount, tdsAmount, exchdiif,
                                        onAccAmt, crAmount, totalAmount, recptNo, recptDate, paymentReceivedDate, pymtModeId, instrNo, instruDate, bankName,
                                        branchName, narration, checklnvListData, OtherChargesListData, accPaymentId)
                                        .then((data) => {
                                            if (data.error != 1) {
                                                this.setState({ isLoading: false })
                                                toastSuccess("Receipt Updated Succesfully")
                                                setTimeout(() => {
                                                    this.props.navigate('/receiptlist')
                                                }, 2000);
                                            } else {
                                                if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                                    //after session expire.....................
                                                    sessionStorage.clear();
                                                    this.props.navigate("/");
                                                    setTimeout(() => {
                                                        toastError(data.msg);
                                                    }, 2000);
                                                } else {
                                                    toastError(data.data);
                                                }
                                                this.setState({ isLoading: false })
                                            }
                                        }).catch((error) => {
                                            console.log(error)
                                        })
                                }
                            } else {
                                toastError("Please Generate Voucher")
                            }
                        } else {
                            toastError("Total Amounts Not Matched")
                        }
                    }
                    else {
                        toastError("Please Generate Voucher")
                    }
                } else {
                    toastError("Please Select Invoices")
                }
            } else {
                toastError("Please Fill Mandatory Fields")
            }
        }
    }

    // On Cancel Receipt Entry Navigating To Back Page
    onCancleReceiptEntry(e) {
        e.preventDefault()
        this.props.navigate(-1)
    }

    // On Change Payment Received Date
    onPaymentReceivedDate(datetimeZone, date) {
        const adjustedDate = new Date(date - (datetimeZone * 60 * 1000))
        this.setState({ paymentReceivedDate: adjustedDate })
    }

    // Generate Voucher 
    generateVoucher() {
        const { voucherTypeId, memberID, bankAccountId, currencyId, conRate, bankAmount, tdsAmount, exchdiif, onAccAmt,
            crAmount, totalAmount, voucherTypeErr, memberErr, bankAccountErr, bankAmountErr, tdsAmountErr,
            otherChargesListErr, otherChargesList, checkedInvList, proformaInv, isTotalsMatched, recptId, memberAccountID } = this.state

        //Validate Inpute Feilds on save Receipt
        this.inputValidate()
        this.otherInputValidate()
        var isNotBlank = false

        //Checking Total Amount matched 
        var isMatched = false
        const { totalReceivedAmt } = this.calculateTotals();
        var OnAccTotal = parseFloat(totalReceivedAmt) + parseFloat(onAccAmt)
        if (totalAmount != OnAccTotal) {
            // toastError("Total Amount Not Matched")
            this.setState({ isTotalsMatched: false })
            isMatched = false
        } else {
            this.setState({ totalsErr: "", isTotalsMatched: true })
            isMatched = true
        }

        for (let i = 0; i < otherChargesList.length; i++) {
            if (i !== 0) {
                if (otherChargesList[i].account == "" || otherChargesList[i].amount == "" || otherChargesList[i].amount == 0) {
                    otherChargesList.splice(i, 1)
                }
            }
        }

        if (voucherTypeId !== "" && memberID !== "" && bankAccountId !== "" && bankAmount !== ""
            && tdsAmount != null && tdsAmount.toString() != "") {

            if (voucherTypeErr == "" && memberErr == "" && bankAccountErr == "" &&
                bankAmountErr == "" && tdsAmountErr == "" && otherChargesListErr == "") {
                if (checkedInvList.length > 0) {
                    if (isMatched) {
                        var selectedProformaList = []
                        proformaInv.map((data) => {
                            if (data.isSelected) {
                                selectedProformaList.push(data)
                            }
                        })
                        this.setState({ isLoading: true, isReadOnly: true })
                        this.props.generateVoucher_action(voucherTypeId, memberAccountID, bankAccountId,
                            currencyId, conRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount
                            , selectedProformaList, otherChargesList, recptId)
                            .then((data) => {
                                if (data.error != 1) {
                                    //adding some of ledger........................
                                    var ledgerList = data.data.ledger
                                    var ledgerDebitSum = 0
                                    var ledgerCreditSum = 0
                                    var mapLedger;
                                    for (var i = 0; i < ledgerList.length; i++) {
                                        ledgerDebitSum = ledgerDebitSum + ledgerList[i].Debit
                                        ledgerCreditSum = ledgerCreditSum + ledgerList[i].Credit
                                        // if (i == (ledgerList.length - 1)) {
                                        //     mapLedger = {
                                        //         Account: "Total",
                                        //         Credit: ledgerDebitSum,
                                        //         Debit: ledgerCreditSum
                                        //     }
                                        // }
                                    }
                                    if (mapLedger != null) {
                                        ledgerList.push(mapLedger)
                                    }
                                    //adding some of sub-ledger........................
                                    var subledgerList = data.data.subledger
                                    var subledgerDebitSum = 0
                                    var subledgerCreditSum = 0
                                    var mapSubLedger;
                                    for (var i = 0; i < subledgerList.length; i++) {
                                        subledgerDebitSum = subledgerDebitSum + subledgerList[i].Debit
                                        subledgerCreditSum = subledgerCreditSum + subledgerList[i].Credit
                                        if (i == (subledgerList.length - 1)) {
                                            mapSubLedger = {
                                                Account: "Total",
                                                Credit: subledgerDebitSum,
                                                Debit: subledgerCreditSum
                                            }
                                        }
                                    }
                                    if (mapSubLedger != null) {
                                        subledgerList.push(mapSubLedger)
                                    }

                                    this.setState({
                                        isLoading: false,
                                        ledgerList: ledgerList,
                                        subLedgerList: subledgerList
                                    })
                                    this.toggleButtons()
                                } else {
                                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                        //after session expire.....................
                                        sessionStorage.clear();
                                        this.props.navigate("/");
                                        setTimeout(() => {
                                            toastError(data.msg);
                                        }, 2000);
                                    } else {
                                        toastError(data.data);
                                    }
                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            }).catch((e) => {
                                console.log(e)
                            })
                    } else {
                        if (checkedInvList[checkedInvList.length - 1]['recvdAmt'] == '') {
                            toastError("Please Enter Received Amount")
                        } else {
                            toastError("Total Amounts Not Matched")
                        }
                    }
                } else {
                    toastError("Please Select Invoices")
                }
            }
            else {
                toastError("Please Fill Mandatory Fields")
            }
        }
    }

    // on clear Voucher 
    clearVoucher() {
        this.setState({ isReadOnly: false, ledgerList: [], subLedgerList: [] })
        this.toggleButtons()
    }

    render() {
        const { isLoading, isOpen, isDelOpen, isView, isReadOnly, isGenVoucherDisabled, isAdd, isDelete, isUpdate, isTotalsMatched, accPaymentId, voucherTypeId, memberID, memberAccountID, bankAccountId, currency, currencyId, conRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receivedAmt, ledDebAmt, ledCrAmt, subLedDebAmt, subLedCrAmt, narration, recptNo, recptId, recptDate, paymentReceivedDate, pymtModeId, instrNo, instruDate, bankName, branchName, voucherTypeList, memberList, bankAccountList, otherChargesList, otherChargesBlankItems, paymentModeList, SelectedInv, checkedInvList, checkedAll, tableRows, otherCharges, otherChargesAccountList, proformaInv, ledgerList, subLedgerList, isContinue, otherChargesAccountTypeListId, otherChargesAccountTypeList, loginAccesslist, isTotalAmountAvailable, voucherTypeErr, memberErr, bankAccountErr, bankAmountErr, tdsAmountErr, pymtModeErr, otherChargesListErr, totalsErr, from } = this.state
        const { totalAmt, totalDueAmt, totalIgst, totalCurrPend, totalReceivedAmt } = this.calculateTotals()

        return (<>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <ToastContainer />
            {/* {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <companyNameHeader /> : <HeaderWithLogo />
                } */}
            <Header />
            <section class="receipt-section" style={{ marginBottom: '50px', marginTop: '125px' }}>
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-lg-12">
                            <div class="card ">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-5 col-5">
                                            <h4 class="heading_title_text">Receipt Add</h4>
                                        </div>
                                        <div class="col-md-7 col-7 text-right">
                                            <div class="card-header-action">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-container p-2 mt-2">
                                    <div className="row ">
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Voucher Type<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    className="form-control"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={voucherTypeId}
                                                    disabled={isView || isReadOnly || isUpdate}
                                                    onChange={(e) => this.setState({ voucherTypeId: e.target.value, voucherTypeErr: "" })}
                                                >
                                                    <option>Select</option>
                                                    {voucherTypeList.length > 0 && voucherTypeList.map(data => (
                                                        <option key={data.VoucherTypeID} value={data.VoucherTypeID}>{data.VoucherTypeName}</option>
                                                    ))}
                                                </select>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{voucherTypeErr}</span>}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Company Name<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    className="form-control"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={memberID}
                                                    disabled={isView || isReadOnly || isUpdate}
                                                    onChange={(e) => this.selectMember(e, [], '')}
                                                >
                                                    <option>Select</option>
                                                    {memberList.length > 0 && memberList.map((data) => (
                                                        <option key={data.Code} value={data.Code}
                                                        >{data.Description}</option>
                                                    ))}
                                                </select>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{memberErr}</span>}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Bank Account<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    className="form-control"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={bankAccountId}
                                                    disabled={isView || isReadOnly}
                                                    onChange={(e) => this.setState({ bankAccountId: e.target.value, bankAccountErr: "" })}
                                                >
                                                    <option>Select</option>
                                                    {bankAccountList.length > 0 && bankAccountList.map((data) => (
                                                        <option key={data.BankID} value={data.BankID}>{data.Name}</option>
                                                    ))}
                                                </select>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{bankAccountErr}</span>}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Currency</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    disabled={true}
                                                    value={currency}
                                                />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">

                                                <label>Con.Rate</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    disabled={true}
                                                    value={conRate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Bank Amount<span style={{ color: 'red' }}>*</span> </label>
                                                <input type="number" className="form-control" name="bankAmount"
                                                    value={bankAmount}
                                                    disabled={isView || isReadOnly}
                                                    maxLength={'16'}
                                                    onChange={(e) =>
                                                        e.target.value >= 0 && this.setState({ bankAmount: e.target.value, bankAmountErr: "" })}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onBlur={(e) => this.handleBankAmount(e)}
                                                />
                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{bankAmountErr}</span>} */}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>TDS Amount<span style={{ color: 'red' }}>*</span></label>
                                                <input type="number" className="form-control" name=""
                                                    value={tdsAmount}
                                                    maxLength={'16'}
                                                    disabled={isView || isReadOnly}
                                                    onChange={(e) => e.target.value >= 0 && this.setState({ tdsAmount: e.target.value, tdsAmountErr: "" })}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.handletdsAmount(e)}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{tdsAmountErr}</span>}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Exch Diff</label>
                                                <input type="number" className="form-control" name=""
                                                    value={exchdiif}
                                                    maxLength={'16'}
                                                    disabled={isView || isReadOnly}
                                                    onChange={(e) => e.target.value >= 0 && this.setState({ exchdiif: e.target.value })}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.setState({ exchdiif: parseFloat(e.target.value).toFixed(2) })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>on Acc Amt</label>
                                                <input type="number" className="form-control" name=""
                                                    value={onAccAmt}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Cr Amount</label>
                                                <input type="number" className="form-control" name=""
                                                    value={crAmount}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.setState({ crAmount: parseFloat(e.target.value).toFixed(2) })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div class="form-group">
                                                <label>Total Amount</label>
                                                <input type="number" className="form-control" name=""
                                                    value={totalAmount}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {<span className='text-danger text-start text-left d-block mt-1'>{totalsErr}</span>}
                                    <div className="row mt-1">
                                        <div className="table-responsive mb-3">
                                            <div
                                                className="btn-group mb-3"
                                                role="group"
                                                aria-label="Basic example"
                                                style={{ float: "right" }}
                                            >
                                                <button
                                                    type="button"
                                                    // className="btn btn-dark p-1 btn-small m-0"
                                                    className="btn btn-dark sel-per p-1 btn-small m-0"
                                                    disabled={isView || isReadOnly || !isTotalAmountAvailable || isUpdate}
                                                    onClick={e => this.toggleModal()}
                                                >
                                                    Select Proforma Invoice(s)
                                                </button>
                                            </div>
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3">
                                                <thead>
                                                    <tr>
                                                        <th>Proforma Invoice No.</th>
                                                        <th>Proforma Date</th>
                                                        <th>Service</th>
                                                        <th> Taxable Amount</th>
                                                        <th>Tax Type</th>
                                                        <th>CGST </th>
                                                        <th>SGST </th>
                                                        <th>IGST </th>
                                                        <th>Total Payable </th>
                                                        <th>Outstanding</th>
                                                        <th>Received Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        checkedInvList.length > 0 && checkedInvList.map((data) => (
                                                            data.isSelected == 1 &&
                                                            <tr key={data.id}>
                                                                <td>{data.no}</td>
                                                                <td>{new Date(data.Date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                                <td>{data.service}</td>
                                                                <td>{data.totalDue}</td>
                                                                <td>{data.taxType}</td>
                                                                <td>{data.cgst}</td>
                                                                <td>{data.sgst}</td>
                                                                <td>{data.igst}</td>
                                                                <td>{data.Amount}</td>
                                                                <td>{data.currPend}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        // id={data.id}
                                                                        className="form-control"
                                                                        value={data.recvdAmt}
                                                                        disabled={isView || isReadOnly || data.isReadOnly}
                                                                        maxLength={'16'}
                                                                        onChange={(e) => this.handleReceivedAmount(e, data.id)}
                                                                        // onKeyDown={(e) => this.preventNegative(e)}
                                                                        onInput={(e) => this.maxLengthCheck(e, 16)}
                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                    // onBlur={(e) => this.totalAmtsVal(e, data.id)}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{data.recvdAmtErr}</span>}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                    <tr key={Math.random()}>
                                                        <td>Total</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            {totalAmt}
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            {totalIgst}
                                                        </td>
                                                        <td>
                                                            {totalDueAmt}
                                                        </td>
                                                        <td>
                                                            {totalCurrPend}
                                                        </td>
                                                        <td>
                                                            {totalReceivedAmt}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className=" mb-1"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "right" }}
                                        >
                                            {!isGenVoucherDisabled && (
                                                <button
                                                    type="button"
                                                    className="btn btn-dark p-1 sel-per btn-small m-0"
                                                    style={{ float: "right" }}
                                                    disabled={isView}
                                                    onClick={(e) => this.generateVoucher(e)}
                                                >
                                                    Generate Voucher
                                                </button>
                                            )}
                                            {isGenVoucherDisabled && (
                                                <button
                                                    type="button"
                                                    className="btn btn-dark p-1 btn-small m-0"
                                                    style={{ float: "right" }}
                                                    onClick={this.clearVoucher}
                                                >
                                                    Clear Voucher
                                                </button>
                                            )}
                                        </div>
                                        {
                                            isGenVoucherDisabled && this.createLedgerTable()
                                        }
                                        {
                                            isGenVoucherDisabled && this.createSubLedgerTable()
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div class="form-group">
                                                <label>Narration</label>
                                                <textarea
                                                    className="form-control"
                                                    defaultValue={"\n"}
                                                    value={narration}
                                                    disabled={isView}
                                                    maxLength={'500'}
                                                    onChange={(e) => this.setState({ narration: e.target.value, })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Receipt no </label>
                                                <input type="text" className="form-control" name=""
                                                    value={recptNo} disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Receipt Date</label>
                                                <DatePicker
                                                    selected={recptDate}
                                                    dateFormat={"dd/MM/yyyy"} className="form-control" disabled={true}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="Receipt Date"
                                                    dayClassName={() => "example-datepicker-day-class"}
                                                    popperClassName="example-datepicker-class" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Payment Received Date</label>
                                                <DatePicker
                                                    selected={paymentReceivedDate}
                                                    dateFormat={"dd/MM/yyyy"}
                                                    className="form-control"
                                                    onChange={(date) => this.onPaymentReceivedDate(date.getTimezoneOffset(), date.getTime())}
                                                    peekNextMonth
                                                    disabled={isView}
                                                    maxDate={new Date()}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="Payment Receipt Date" dayClassName={() => "example-datepicker-day-class"}
                                                    popperClassName="example-datepicker-class"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Payment Mode<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    className="form-control"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={pymtModeId}
                                                    disabled={isView}
                                                    onChange={(e) => this.setState({ pymtModeId: e.target.value, pymtModeErr: "" })}
                                                >
                                                    <option>Select</option>
                                                    {paymentModeList.length > 0 && paymentModeList.map((data) => (
                                                        <option key={data.PaymentModeID} value={data.PaymentModeID}>{data.Name}</option>
                                                    ))}
                                                </select>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{pymtModeErr}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Instrument no</label>
                                                <input type="text" className="form-control" name=""
                                                    value={instrNo} disabled={isView}
                                                    maxLength={'50'}
                                                    onChange={(e) => this.setState({ instrNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Instrument Date</label>
                                                <DatePicker
                                                    selected={instruDate} onChange={(date) => this.setState({ instruDate: date })}
                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                    disabled={isView}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="Receipt Date"
                                                    minDate={recptDate}
                                                    dayClassName={() => "example-datepicker-day-class"}
                                                    popperClassName="example-datepicker-class" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Bank Name</label>
                                                <input type="text" className="form-control" name=""
                                                    value={bankName} disabled={isView}
                                                    maxLength={'500'}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div class="form-group">
                                                <label>Branch Name</label>
                                                <input type="text" className="form-control" name=""
                                                    value={branchName} disabled={isView}
                                                    maxLength={'250'}
                                                    onChange={(e) => this.setState({ branchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className=" mb-1 mt-2"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "right", textAlign: "right" }}
                                        >
                                            {
                                                isAdd &&
                                                <button type="button" className="btn btn-success ms-2"
                                                    disabled={!this.getWriteAccess()}
                                                    onClick={this.saveReceiptEntry}
                                                >
                                                    Save
                                                </button>
                                            }
                                            {
                                                isUpdate &&
                                                <button type="button" className="btn btn-success ms-2"
                                                    disabled={!this.getUpdateAccess()}
                                                    onClick={this.updateReceiptEntry}
                                                >
                                                    Update
                                                </button>
                                            }
                                            {
                                                (isUpdate || isView) &&
                                                <button type="button" className="btn btn-danger ms-2"
                                                    disabled={!this.getDeleteAccess()}
                                                    onClick={this.toggleDelModal}
                                                >
                                                    Delete
                                                </button>
                                            }
                                            <button type="button" className="btn btn-warning ms-2  text-white"
                                                onClick={this.onCancleReceiptEntry}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal show={isDelOpen} onHide={() => this.setState({ isDelOpen: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body><p class="pop_label">Do you really want to delete this  record?</p></Modal.Body>
                <Modal.Footer>
                    <button type="button" class="btn btn-del-pop" style={{ color: 'black' }}
                        onClick={(e) => this.handleDelete(e)}
                    >Yes</button>
                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px', color: 'black' }} onClick={() => this.setState({ isDelOpen: false, })}>No</button>
                </Modal.Footer>
            </Modal>

            <Modal show={isOpen} onHide={() => this.setState({ isOpen: false })} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title><h5 className="modal-title" id="staticBackdropLabel">
                        Proforma Invoice
                    </h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive ">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th className="text-center">
                                        <input type="checkbox" class="custom-control-input" checked={checkedAll} />
                                        <label style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} class="custom-control-label" onClick={(e) => this.selectAllInv(e)}></label>
                                    </th>
                                    <th className="text-center">Proforma Invoice No</th>
                                    <th>Proforma Invoice Date</th>
                                    <th>Service</th>
                                    <th>Total Payable</th>
                                    <th>Outstanding</th>
                                </tr>
                            </thead>
                            <tbody>
                                {console.log('proformaInv', proformaInv)}
                                {proformaInv.length > 0 && proformaInv.map((data, index) => (
                                    <tr key={Math.random()} onClick={(e) => this.handleCheckedInv(e, data.id)} >
                                        <td className="text-center">
                                            <input type="checkbox" class="custom-control-input" value={data.isSelected} checked={data.isSelected} onChange={(e) => this.handleCheckedInv(e, data.id)} />
                                            <label class="custom-control-label" style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} ></label>
                                        </td>
                                        <td className="text-center">{data.no}</td>
                                        <td>{new Date(data.Date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                        <td>{data.service}</td>
                                        <td>{data.Amount}</td>
                                        <td>{data.currPend}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn ad-fil-btn"
                        data-bs-dismiss="modal"
                        style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                        onClick={this.handleContinue}
                    >
                        Continue
                    </button>
                </Modal.Footer>
            </Modal>
        </>)
    }
}

export default withRouter(connect(null, { fill_action, receipt_entry_save_action, deleteReceipt_action, receiptUpdate_action, receiptDetails_action, proformaInvoice_action, receiptNo_action, generateVoucher_action })(ReceiptAU));
